import axios from "axios";
import api from "../api";
import axiosServices from "../../../services/axiosServices";
import axiosServicesOnboarding from "../../../services/axiosServicesOnboarding";

export const authApi = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

const AuthModule = () => {
  return {
    Login: function (data) {
      return authApi.post("Auth", data);
    },

    ResetPassword: function (data) {
      // return authApi.post("identity/Agent/setnewREMOVED", data);
      return authApi.post("identity/Agent/completeforgotREMOVED", data);
    },

    // Customer/states
    CustomerStates: function (data) {
      return axiosServicesOnboarding.get("customer/states");
    },

    // Customer/lga/1
    CustomerLga: function (data) {
      return axiosServicesOnboarding.get(`customer/lga/${data}`);
    },

    CurrentUser: function (data) {
      return api.get("Auth/sessiondetails");
    },

    AccountDetails: function (data) {
      return axiosServicesOnboarding.get(`Agent/account-details/${data}`);
    },

    CustomerAccounts: function (data) {
      return axiosServicesOnboarding.get(`Customer/get-accounts/${data}`);
    },

    // **********************************************************************************************************************************************************************************************

    LinenTransaction: function (data) {
      return api.get("wallet/Transaction/liens");
    },

    ServiceToday: function (data) {
      return api.get(`wallet/Wallet/report/service/today`);
    },

    ServiceWeek: function (data) {
      return api.get("wallet/Wallet/report/service/this_week");
    },

    AgentDetails: function (data) {
      const { page, limit } = data;
      return api.get(
        `/transactions/report/superdealer/performance/top-resselers?customer_id=501&service_codes=100,101,102,103,106,105&per_page=${limit}&page=${page}`
      );
    },
  };
};

export const AuthService = {
  auth: AuthModule,
};
